module.exports = __webpack_public_path__ + "98f8ec847fe3436793921771c8210ca2.jpg";